<template>
  <div v-if="show_body" style="min-height: 100%; position: relative;">
    <!-- 测评答题 -->
    <!-- 他评必传的参数 data  pattern  taTextObject  intro -->
    <answer-questions :cid_type="'test65'" :array="data.list" :interruptShow="interruptShow" :data_="data" :pattern='pattern' :taTextObject="taTextObject"  :intro="data.intro?data.intro.split('\r'):[]" @saveHeReview="saveHeReview" @saveReportHandle="saveReportHandle"></answer-questions>
    <!-- 自己 -->
    <van-popup class="radius" :close-on-click-overlay="false" v-model="kc_show">
      <div class="pop pr text-center">
        <p>你的专属报告已生成</p>
        <p>长按识别关注公众号“立即查看”</p>
        <!-- <img src="../../../assets/cep_ewm.png" /> -->
        <div class="text-center">
          <img class="qr-box" :src="qrcode" alt="" />
        </div>
      </div>
    </van-popup>
    <!-- 未购买 -->
    <van-popup class="pub_alert" v-model="is_buy" :close-on-click-overlay="false">
      <div class="confirm_box">
        <h2>此测评属于最佳工作模式课程，快去购买课程测评吧</h2>
        <div class="btn_group">
          <router-link class="confirm" :to="{
            path:'/course_details',
            query:{
              bid:2
            }
          }">购买最佳工作模式课程</router-link>
        </div>
      </div>
    </van-popup>
    <!-- 判断链接是否失效 -->
    <van-popup class="pub_alert" v-model="failureShow" :close-on-click-overlay="false">
        <div class="confirm_box">
            <h2 class="on">{{failureMsg}}</h2>
        </div>
    </van-popup>
    <!-- 关卡介绍 -->
    <public-level :level_list_id="level_list_id"  :cpBool="true"></public-level>
  </div>
</template>
<script>
import {
  test65_index,
  test65_answer,
  test65_ta_answer,
  test65_ta_index,
  debug
} from '@/api/measurement'
import AnswerQuestions from "@c/measurement/answer-questions";
import {
  queryString,
  getStorage,
  setStorage,
  deleteStorage
} from '@/utils/tools'
import { shareCon} from '@/utils/wxconfig'
import PublicLevel from '@c/course/public-level'
export default {
  data() {
      return {
        type_obj: {
          evaluation_id: "",
          evaluation_name: "",
          evaluation_id: "",
          nickname: ""
        },
        show_body: false,
        qrcode: "",
        //
        nickname: "",
        kc_show: false,
        // 模式
        pattern: false,
        data: {},
        // 上一页面路由
        formPath: '',
        failureShow:false,
        interruptShow:false,
        failureMsg:'',
        // 他评显示文案
        taTextObject:{},
        // 获取关卡介绍的项目id
        level_list_id:''
      }
    },
    components: {
      AnswerQuestions,
      PublicLevel
    },
    computed: {
      is_buy(){
        return (!this.data.is_buy && !this.data.msg && !this.pattern)
      }
    },
    methods: {
      /*
       *@param: arr
       *@return: 
       *@Description: 获得他评提交的答题数据
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-05 11:40:57
      */
      saveHeReview(arr){
        let q = this.$route.query;
        test65_ta_answer({
          ta_uid: q.ta_uid,
          answer: JSON.stringify(arr)
        }).then((data) => {
          
        })
      },
      /*
       *@param: arr
       *@return: 
       *@Description: 获得提交的答题数据
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-01 15:28:13
      */
      saveReportHandle(arr){
        this.$toast.loading({
          mask: true,
          message: "提交中..."
        });
        // 自己
        test65_answer({
          answer: JSON.stringify(arr)
        }).then((data) => {
          if (this.subscribe) {
            // 提交删除缓存
            deleteStorage(this.$route.path);
            let q = this.$route.query;
            if (this.formPath === '/test65_report') {
              this.$router.back();
            } else {
              q['uid'] = data.uid;
              this.$router.push({
                path: '/test65_report',
                query: q
              })
            }
          } else {
            this.kc_show = true;
          }
        });
      },
      pullData() {
        //调用加载中
        this.$emit('loadingHandle',true,"拼命加载中...");
        if (!this.pattern) {
          // 自己
          let q = this.$route.query;
          // 获取关卡信息
          this.level_list_id = q.level_list_id?q.level_list_id:'';
          let obj = {
            share_uid: q.share_uid || "",
            channel: q.channel || ""
          };
          if(this.$route.query.code){
            obj['code'] = this.$route.query.code;
          }
          test65_index(obj).then((data) => {
              this.data = data;
              if (data.code != 10002) {
                this.type_obj.evaluation_id = data.cid;          
                this.type_obj.evaluation_name = data.headtitle;          
                this.type_obj.evaluation_user_id = data.uid;          
                this.type_obj.nickname = data.nickname;          
                this.type_obj.path = this.$route.path;       
                shareCon("measurement_new", this, this.type_obj);
                //判断是否是已购买课程并且链接已使用或者失效
                if(data.msg){
                  this.failureMsg = data.msg;
                  this.failureShow = true;
                }else{
                  //判断是否是已购买课程并且有本地缓存
                  if (data.is_buy && window.localStorage.getItem(this.$route.path)) {
                    this.interruptShow = true;
                  }
                  // 设置数据
                  this.initCptData(data);
                }
                // 显示
                this.show_body = true;

              } else {
                if (this.formPath === '/test65_report') {
                  this.$router.back();
                } else {
                  this.$router.push({
                    path:'/test65_report',
                    query:this.$route.query
                  });
                }

              };
              //关闭加载中
              this.$emit('loadingHandle',false);
              // 神策统计--打开页面时触发
              sensors.track('evaluationPage', {
                evaluation_id: String(data.cid),
                evaluation_name: data.headtitle,
                evaluation_url: window.location.href,
                evaluation_page_title: data.headtitle,
                share_user_id: this.$route.query.share_uid ? this.$route.query.share_uid : "",
                channel_name: this.$route.query.channel ? this.$route.query.channel : ""
              })
            })
        } else {
          let obj = {
            ta_uid: this.$route.query.ta_uid
          };
          if(this.$route.query.code){
            obj['code'] = this.$route.query.code;
          }
          // 别人
          test65_ta_index(obj).then((data) => {
              this.data = data;
              //关闭加载中
              this.$emit('loadingHandle',false);
              if (data.code != 10002) {
                this.type_obj.evaluation_id = data.cid;          
                this.type_obj.evaluation_name = data.headtitle;          
                this.type_obj.evaluation_user_id = data.uid;          
                this.type_obj.nickname = data.nickname;          
                this.type_obj.path = this.$route.path;          
                shareCon("measurement_new", this, this.type_obj);
                let off = data.uid == this.$route.query.ta_uid;
                if (off) {
                  // 自己评自己
                  this.$router.push('/test65_report');
                  return
                }
                this.show_body = true;
                // 设置数据
                this.initCptData(data);
                // 显示
              }else{
                if(!data.data.ta_nickname){
                  if (this.formPath === '/test65_report') {
                    this.$router.back();
                  } else {
                    this.$router.push({
                      path:'/test65_report',
                      query:this.$route.query
                    });
                  }
                }else{
                  this.show_body = true;
                }
                
              }
              let ta_nickname = data.code == 10002?data.data.ta_nickname:data.ta_nickname;
              this.taTextObject = {
                path:'test65',
                toPath:'/measurement_public_p1',
                arr:[
                `你已完成对<span style="font-weight: bold;color:#EB5032;">${ta_nickname}</span>的能力评价，为表示对你的谢意，送你一份限时优惠。`
                ]
              };
            })
        }

      },
      initCptData(data) {
        this.subscribe = data.subscribe;
        if (!data.need_subscribe) {
          this.subscribe = true;
        }
        this.qrcode = data.qrcode;
        //
        this.nickname = data.nickname;
        document.title = data.headtitle;
      },
      
      setPattern() {
        let isMy = this.$route.query.ta_uid;
        if (isMy) {
          this.pattern = true;
        } else {
          this.pattern = false;
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => { //  这里的vm指的就是vue实例，可以用来当做this使用
        vm.formPath = from.path;
      })
    },
    created() {
      this.setPattern();
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.progress {
  position: fixed;
  height: 8px;
  left: 0;
  top: 0;
  z-index: 3;
  background: red;
  transition: all .3s;
}

.pg-num {
  position: fixed;
  padding: 10px;
  top: 10px;
  right: 10px;
  z-index: 4;
  background: red;
  transition: all .3s;
  color: #fff;
  border-radius: 30px;
}
.m-error{
  bottom: 60px;
  position: fixed;
  width: 80px;
  line-height: 80px;
  height: 80px;
  text-align: center;
  right: 40px;
  z-index: 4;
  background: #fff;
  transition: all .3s;
  color: #F57F17;
  border: 2px solid #F57F17;
  border-radius: 50%;
  box-sizing: border-box;
}
.error-pop{
  background: transparent;
}
.error{
  background-color: #ffffff;
  width: 690px;
  padding: 30px;
  border-radius: 15px;
  h3{
    font-size: 34px;
    color: #333;
  }
  textarea{
    margin: 40px auto 90px;
    resize:none;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 8px;
    line-height: 39px;
    width: 100%;
    background-color: #f5f5f5;
  }
  .error-footer{
    border-top:1px solid #d3d3d3;
    display: flex;
    position: absolute;
    bottom:0;
    width: 100%;
    left: 0;
    line-height: 90px;
    a{
      flex: 1;
      text-align: center;
      font-size: 34px;
      color: #333;
      &:nth-child(1){
        color: #EB5032;
      }
      &:nth-child(2){
        color: #666666;
        border-left: 1px solid #d3d3d3;
      }
    }
  }
}

.mt32 {
  margin-top: 32px;
}

.pt32 {
  padding-top: 32px;
}

.pb-public {
  padding: changeRem(0.425)+px;
}


.pop {
  img {
    max-width: 8rem;
  }
}

.radius {
  border-radius: 10px;
}

.pop {
  width: 8rem;
  padding-bottom: 80px;
  p:nth-child(1) {
    padding-top: 50px;
    font-size: 34px;
    line-height: 80px;
    font-weight: bold;
    color: #F57F17;
  }
  p:nth-child(2) {
    color: #333;
    font-size: 30px;
    line-height: 80px;
  }
  img {
    width: 80%;
  }
}

.confirm_box {
  h2 {
    padding: 40px 30px;
  }
  h2.on {
    padding: 60px 30px;
  }
  p {
    margin-bottom: 50px;
    font-size: 26px;
    color: #666;
  }
  .btn_group {
    .confirm {
      color: #999999;
    }
    .cancel {
      color: #EB5032;
    }
  }
}

// 弹出开始测评说明
.answer-sheet {
  transition: all 2s;
  position: fixed;
  z-index: 998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.answer-sheet.on {
  left: -1500px;
}
</style>
